module.exports = __webpack_public_path__ + "img/section-meter-water-meter-cold-sm.4d757c2f.svg";